import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import Tip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import Home from "../Home";
import {
  fetchTerritoryBUList,
  fetchTerritoryDivisionList,
  fetchTerritoryBranchList,
  fetchTerritorySalesOfficeList,
  fetchTerritoryList,
} from "../TerritoryDefinition/actions";
import {
  fetchEmployeeList,
  getTerritoryAllocationList,
  saveTerritoryAllocation,
  searchEmployee,
} from "./actions";
import "react-dropdown/style.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Spinner } from "react-bootstrap";
import { Select } from "antd";
import AsyncSelect from "react-select/async";
import Breadcrumb from "../../components/Breadcrumb";
import Maintenance from "../Maintenance";
import _ from "lodash";

const { Option } = Select;

const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function TerritoryAllocation() {
  var selectedId = "";
  const [role, setRole] = useState();
  const [size, setSize] = useState("default");
  const [lang] = useTranslation("language");
  const [buID, setBuID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [divisionID, setDivisionID] = useState("");
  const [salesOfficeID, setSalesOfficeID] = useState("");
  const [territoryID, setTerritoryID] = useState("");
  const [selectedTerritoryId, setSelectedTerritoryId] = useState("");
  const [buName, setBuName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [salesOfficeName, setSalesOfficeName] = useState("");
  const [territoryName, setTerritoryName] = useState("");
  const [duration, setDuration] = useState(0);
  const [toggleDuration, setToggleDuration] = useState(false);
  const [applyToNext, setApplyToNext] = useState("");
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [warning, setWarning] = useState("");
  const [error, setError] = useState("");
  const [searchText, setSearchText] = useState("");
  const [employeeId, setEmployeeId] = useState();
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [allocAPIFail, setAllocAPIFail] = useState(false);
  const [limit, setLimit] = useState(40);
  const [total, setTotal] = useState(0);
  const [disableSave, setDisableSave] = useState(false);
  const [finalObj, setfinalObj] = useState({});
  const [noData, setNoData] = useState();
  const [noSearchData, setNoSearchData] = useState();
  const [loading, setLoading] = useState();
  const [resultLoading, setResultLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [buLoading, setBULoading] = useState(false);
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [territoryLoading, setTerritoryLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [buList, setBuList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);
  const [territoryList, setTerritoryList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListing, setEmployeeListing] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [warningList, setWarningList] = useState([]);
  const [territoryAllocationList, setTerritoryAllocationList] = useState([]);
  const [selectedTerritoryAllocationList, setSelectedTerritoryAllocationList] =
    useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.territoryAllocation")}`,
      path: "",
    },
  ];
  useEffect(() => {
    let flag = false;
    Object.values(finalObj).forEach((item) => {
      if (item === null) {
        flag = true;
      }
    });
    if (flag) {
      setDisableSave(true);
    } else {
      setDisableSave(false);
    }
  }, [finalObj]);
  const options = [
    {
      type: "group",
      name: "Atlanta",
      items: [
        { name: "Workshop One", value: "1" },
        { name: "Workshop Two", value: "2" },
      ],
    },
    {
      type: "group",
      name: "Charleston",
      items: [
        { name: "Workshop Three", value: "3" },
        { name: "Workshop Four", value: "4" },
        { name: "Workshop Five", value: "5" },
      ],
    },
    {
      type: "group",
      name: "Inactive",
      items: [{ name: "Inactive Workshop", value: "100" }],
    },
  ];

  useEffect(() => {
    setBuID("");
    setBuName("");
    setDivisionID("");
    setDivisionName("");
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    let wwid = sessionStorage.getItem("WWID");
    let cnt = duration == 1 ? 1 : 0;
    getTerritoryBUList(wwid, cnt);
  }, [duration, toggleDuration]);

  useEffect(() => {
    const role = sessionStorage.getItem("User role");
    const bu = sessionStorage.getItem("Territory BU");
    setRole(role);
    let cnt = duration == 1 ? 1 : 0;
    // if (role === "Admin" || role === "BusinessOperation") {
    // setDuration("1");
    // cnt = 1
    // } else {
    // cnt = 0
    // setDuration("0");
    // }
    setBuList(JSON.parse(bu));
    let wwid = sessionStorage.getItem("WWID");
    !sessionStorage.getItem("Territory BU") && getTerritoryBUList(wwid, cnt);
    sessionStorage.setItem("return_url", "/territoryAllocation");
    if (sessionStorage.getItem("token")) {
      sessionStorage.setItem("return_url", "");
    }
  }, []);

  useEffect(() => {
    setTerritoryAllocationList([]);
  }, [buID, divisionID, branchID, salesOfficeID, territoryID, duration]);

  /*** 
  @purpose : Get BU list
  @Parameter : {}
  **/
  const getTerritoryBUList = async (wwid, cnt) => {
    setBULoading(true);
    await fetchTerritoryBUList(wwid, cnt).then((res) => {
      if (res && res[0] && res[0].maintenanceWindowFlag) {
        setMaintenance(true);
      }
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.buID, label: item.orgName });
      }
      setBuList(newList);
      setBULoading(false);
      sessionStorage.setItem("Territory BU", JSON.stringify(newList));
    });
  };

  const handleId = (id) => {
    selectedId = id;
    setSelectedTerritoryId(id);
    let wwid = sessionStorage.getItem("WWID");
    let cnt = duration == 1 ? 1 : 0;
    !sessionStorage.getItem("Territory BU") && getTerritoryBUList(wwid, cnt);
  };
  const handleFinalArray = (i, val) => {
    let obj = { ...finalObj };
    obj[i] = val;
    setfinalObj(obj);
  };
  /*** 
  @purpose : Handle BU change
  @Parameter : {value}
  **/
  const handleBUChange = async (value) => {
    setDivisionID("");
    setDivisionName("");
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setDivisionLoading(true);
      let data = value.label;
      setBuName(data);
      let id = value.value;
      setBuID(id);
      let cnt = duration == 1 ? 1 : 0;
      await fetchTerritoryDivisionList(id, cnt).then((res) => {
        setDivisionLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else {
      setDivisionLoading(false);
      setBuID("");
      setBuName("");
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  const handleClose = () => setShow(false);

  const modalShow = () => setShow(true);

  const handleCloseErrorMessage = () => setShowErrorMessage(false);
  const handleCloseErrorMessageAPIFail = () => setAllocAPIFail(false);

  /*** 
  @purpose : Handle division change
  @Parameter : {value}
  **/
  const handleDivisionChange = async (value) => {
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setBranchLoading(true);
      let data = value.label;
      setDivisionName(data);
      let id = value.value;
      let cnt = duration == 1 ? 1 : 0;
      setDivisionID(id);
      await fetchTerritoryBranchList({
        buID: buID,
        divisionID: id,
        currentMonth: cnt,
      }).then((res) => {
        setBranchLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.branchID, label: item.orgName });
        }
        setBranchList(list);
      });
    } else {
      setBranchLoading(false);
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Handle branch change
  @Parameter : {}
  **/
  const handleBranchChange = async (value) => {
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setSalesOfficeLoading(true);
      let data = value.label;
      setBranchName(data);
      let id = value.value;
      setBranchID(id);
      await fetchTerritorySalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: id,
        currentMonth: duration,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      setSalesOfficeLoading(false);
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Handle sales office change
  @Parameter : {value}
  **/
  const handleSalesOfficeChange = async (value) => {
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setTerritoryLoading(true);
      setSalesOfficeName(value.label);
      setSalesOfficeID(value.value);
      let cnt = duration == 1 ? 1 : 0;
      await fetchTerritoryList({
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        salesOfficeID: value.value,
        currentMonth: cnt,
      }).then((res) => {
        setTerritoryLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.id, label: item.territory_set_name });
        }
        setTerritoryList(list);
      });
      // await fetchEmployeeList({
      //   salesOfficeID: value.value,
      // }).then((res) => {
      //   setEmployeeData(res);
      //   let data = [];
      //   let obj = {};
      //   res.map((item) => {
      //     obj = { label: item.org_name_ja, options: item.employees };
      //     data.push(obj);
      //   });
      //   let newList = [];
      //   for (let i = 0; i < data.length; i++) {
      //     let list = [];
      //     for (let index = 0; index < data[i].options.length; index++) {
      //       const item = data[i].options[index];
      //       list.push({
      //         value: item.employee_id,
      //         label: item.name_ja + " [" + item.employee_wwid + "]",
      //       });
      //     }
      //     newList.push({ label: data[i].label, options: list });
      //   }

      //   setEmployeeList(newList);
      // });
    } else {
      setTerritoryLoading(false);
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Handle territory change
  @Parameter : {value}
  **/
  const handleTerritoryChange = (value) => {
    if (value) {
      setTerritoryID(value.value);
      setTerritoryName(value.label);
    } else {
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Validate form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let errors = {
      bu: "",
      division: "",
      branch: "",
      salesOffice: "",
      territory: "",
      duration: "",
    };

    if (buID === "") errors.bu = "errorMessages.PROVIDE_BU";
    else errors.bu = "";

    if (divisionID === "") errors.division = "errorMessages.PROVIDE_DIVISION";
    else errors.division = "";

    if (salesOfficeID === "")
      errors.salesOffice = "errorMessages.PROVIDE_SALES_OFFICE";
    else errors.salesOffice = "";

    if (branchID === "") errors.branch = "errorMessages.PROVIDE_BRANCH";
    else errors.branch = "";

    if (territoryID === "")
      errors.territory = "errorMessages.PROVIDE_TERRITORY";
    else errors.territory = "";

    if (duration === "") errors.duration = "errorMessages.PROVIDE_DURATION";
    else errors.duration = "";

    if (
      errors.bu !== "" ||
      errors.division !== "" ||
      errors.salesOffice !== "" ||
      errors.branch !== "" ||
      errors.territory !== "" ||
      errors.duration !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle territory allocation
  @Parameter : {}
  **/
  const handleTerritoryAllocation = async () => {
    setDisableSave(false);
    let empList = [];
    let newList = [];
    if (validateForm()) {
      setTerritoryAllocationList([]);
      setLoading(true);
      setNoData(false);
      let body = {
        salesOfficeID: salesOfficeID,
        territoryID: territoryID,
        currentMonth: duration,
        limit: 0,
        totalRecords: 0,
      };
      await fetchEmployeeList({
        salesOfficeID: salesOfficeID,
        territoryID: territoryID,
        currentMonth: duration,
      }).then((res) => {
        setEmployeeData(res);
        empList = res;
        let data = [];
        let obj = {};
        res.map((item) => {
          obj = { label: item.org_name_ja, options: item.employees };
          data.push(obj);
        });
        for (let i = 0; i < data.length; i++) {
          let list = [];
          for (let index = 0; index < data[i].options.length; index++) {
            const item = data[i].options[index];
            list.push({
              value: item.employee_id,
              label: item.name_ja + " [" + item.employee_wwid + "]",
            });
          }
          newList.push({ label: data[i].label, options: list });
        }

        setEmployeeList(newList);
        setEmployeeListing(newList);
      });
      await getTerritoryAllocationList(body).then((res) => {
        let list = [];
        let newList1 = [];
        res.data &&
          res.data.map((ter) => {
            empList.map((emp) => {
              emp.employees.map((e) => {
                if (e.employee_id === ter.employee_id) {
                  ter.warning = false;
                  if (e.mr_in_other_salesOffice == "1") {
                    ter.warning = true;
                    list.push(ter.id);
                  }
                  ter.error = false;
                  if (e.is_active_mr == "1") {
                    ter.error = true;
                    setError(selectedTerritoryId);
                    newList1.push(ter.id);
                  }
                }
              });
              setWarningList(list);
              setErrorList(newList1);
            });
          });

        if (res.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (res.data.length === 0) {
            setNoData(true);
            setLoading(false);
            setTerritoryAllocationList([]);
          } else {
            setNoData(false);
            setLoading(false);
            setTerritoryAllocationList(res.data);
            setTotal(res.data[0].total);
          }
        }
      });
    }
  };

  // const handleContainerOnBottom = async () => {
  //   let body = {
  //     salesOfficeID: salesOfficeID,
  //     territoryID: territoryID,
  //     currentMonth: duration,
  //     limit: territoryAllocationList.length,
  //     totalRecords: total,
  //   };
  //   // sessionStorage.setItem("personData", JSON.stringify(body));
  //   if (territoryAllocationList.length <= total && total >= 30) {
  //     await getTerritoryAllocationList(body).then((res) => {
  //       let list = [];
  //       list = territoryAllocationList.concat(res.data);
  //       setTerritoryAllocationList(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    let body = {
      salesOfficeID: salesOfficeID,
      territoryID: territoryID,
      currentMonth: duration,
      limit: territoryAllocationList.length,
      totalRecords: total,
    };
    // sessionStorage.setItem("personData", JSON.stringify(body));
    if (territoryAllocationList.length < total) {
      setLazyLoading(true);
      await getTerritoryAllocationList(body).then((res) => {
        let list = [];
        list = territoryAllocationList.concat(res.data);
        setLazyLoading(false);
        setTerritoryAllocationList(list);
      });
      setLimit(limit + 10);
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
  @purpose : Handle search employee
  @Parameter : {}
  **/
  const handleEmployeeSearch = async (value) => {
    let empList = [];
    let cnt = duration == 1 ? 1 : 0;
    let body = {
      salesOfficeID: salesOfficeID,
      searchText: value,
      cnt,
    };
    let newList = [];
    await searchEmployee(body).then((res) => {
      let arr = [...employeeData];
      arr = arr.concat(res);
      arr.filter(
        (v, i, a) => a.findIndex((v2) => v2.employee_id === v.employee_id) === i
      );
      setEmployeeData(arr);
      empList = res;
      let data = [];
      let obj = {};
      res.map((item) => {
        obj = {
          label: item.org_name_ja ? item.org_name_ja : "NA",
          options: item.employees,
        };
        data.push(obj);
      });

      for (let i = 0; i < data.length; i++) {
        let list = [];
        for (let index = 0; index < data[i].options.length; index++) {
          const item = data[i].options[index];
          list.push({
            value: item.employee_id,
            label: item.name_ja + " [" + item.employee_wwid + "]",
          });
        }
        newList.push({ label: data[i].label, options: list });
      }
      setEmployeeList(newList);
      // return newList;
    });

    let warningIds = [];
    let errorIds = [];
    empList.map((emp) => {
      emp.employees.map((e) => {
        if (e.mr_in_other_salesOffice == "1") {
          warningIds.push(e.employee_wwid);
        }
        if (e.is_active_mr == "1") {
          setError(selectedTerritoryId);
          errorIds.push(e.employee_wwid);
        }
      });
      setWarningList(warningIds);
      setErrorList(errorIds);
    });
    return newList;
  };

  const resetEmployeeList = () => {
    setEmployeeList(employeeListing);
  };

  /*** 
  @purpose : Handle duration change
  @Parameter : {}
  **/
  const handleDurationChange = async (e) => {
    setToggleDuration(!toggleDuration);
    setDuration(e.target.value);
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (branchID) {
      await fetchTerritorySalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        currentMonth: e.target.value ? e.target.value : 0,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    }
    if (e.target.value === 1) {
      setCurrent(true);
      setNext(false);
    } else if (e.target.value === 0) {
      setCurrent(false);
      setNext(true);
    }
  };

  /*** 
  @purpose : Handle employee change
  @Parameter : {}
  **/
  const handleEmployeeChange = (value, i) => {
    if (value) {
      setError("");
      setWarning("");
      let list = [];
      let warning = [];
      employeeData.map((emp) => {
        emp.employees.map((e) => {
          if (e.employee_id === value.value) {
            let arr = [...territoryAllocationList];
            let obj = arr[i];
            obj.warning = false;
            obj.error = false;
            obj.employee_id = value.value;
            if (e.mr_in_other_salesOffice == "1") {
              obj.warning = true;
            }
            if (e.is_active_mr == "1") {
              obj.error = true;
            }
            arr[i] = obj;
            setTerritoryAllocationList(arr);
            if (
              e.is_active_mr == "1" &&
              errorList.includes(selectedTerritoryId) === false
            ) {
              setError(selectedTerritoryId);
              list = [...errorList, selectedTerritoryId];
              setErrorList(list);
            } else if (
              e.is_active_mr == "0" &&
              errorList.includes(selectedTerritoryId)
            ) {
              list = errorList.filter((e) => e !== selectedTerritoryId);
              setErrorList(list);
            }
            if (
              e.mr_in_other_salesOffice == "1" &&
              warningList.includes(selectedTerritoryId) === false
            ) {
              warning = [...warningList, selectedTerritoryId];
              setWarningList(warning);
            } else if (
              e.mr_in_other_salesOffice == "0" &&
              warningList.includes(selectedTerritoryId)
            ) {
              warning = warningList.filter((e) => e !== selectedTerritoryId);
              setWarningList(warning);
            }
          }
        });
      });
      // selectedTerritoryAllocationList.map(item => {
      //   if(item.territoryDefinition === selectedTerritoryId) {
      //     item.allocatedEmployee = value.value
      //     setSelectedTerritoryAllocationList(selectedTerritoryAllocationList)
      //   } else {
      //     let obj = {
      //       territoryDefinition: selectedTerritoryId,
      //       allocatedEmployee: value.value,
      //     };
      //     setSelectedTerritoryAllocationList([
      //       ...selectedTerritoryAllocationList,
      //       obj,
      //     ]);
      //   }

      // })
      let obj = {
        territoryDefinition: selectedTerritoryId,
        allocatedEmployee: value.value,
      };
      setSelectedTerritoryAllocationList([
        ...selectedTerritoryAllocationList,
        obj,
      ]);
      setEmployeeId(value);
    } else {
      setEmployeeId("");
    }
  };

  /*** 
  @purpose : Handle apply to next change
  @Parameter : {}
  **/
  const validateSaveTerritoryAllocation = () => {
    let isValid = true;
    // if (errorList.length !== 0) {
    //   setShowErrorMessage(true);
    //   isValid = false;
    // }
    territoryAllocationList.forEach((item) => {
      if (item.error) {
        isValid = false;
      }
    });
    if (!isValid) {
      setShowErrorMessage(true);
    }
    return isValid;
  };

  /*** 
  @purpose : Handle apply to next change
  @Parameter : {}
  **/
  const saveTerritoryAllocationDetails = async () => {
    const finalArr = [];
    const changedTerritoryDefinitionIds = _.uniq(_.map(selectedTerritoryAllocationList, 'territoryDefinition'));
    territoryAllocationList.forEach((item) => {
      if(changedTerritoryDefinitionIds.includes(item.id)){
        const obj = {};
        obj.territoryDefinition = item.id;
        obj.allocatedEmployee = item.employee_id;
        finalArr.push(obj);
      }
    });
    if (validateSaveTerritoryAllocation()) {
      setResultLoading(true);
      let cnt = duration == 1 ? 1 : 0;
      let nxt = duration == 1 ? 0 : 1;
      let body = {
        params: { currentMonth: cnt, nextMonth: nxt },
        data: finalArr,
      };
      let body1 = {
        params: { currentMonth: 1, nextMonth: 1 },
        data: finalArr,
      };
      const data = applyToNext ? body1 : body;
      await saveTerritoryAllocation(data).then((response) => {
        setResultLoading(false);
        if (response.success === true) {
          setSelectedTerritoryAllocationList([]);
          modalShow();
        } else {
          setAllocAPIFail(true);
        }
      });
    }
  };

  /*** 
  @purpose : Save Territory Allocation
  @Parameter : {}
  **/
  const handleApplyToNext = async (e) => {
    setApplyToNext(e.target.checked);
  };

  /*** 
  @purpose : Handle territory search
  @Parameter : {}
  **/
  const handleTerritorySearch = async (text) => {
    setSearchText(text);
    let value = text ? text : searchText;
    let list = [];
    if (text !== "") {
      list = territoryAllocationList.filter(
        (ter) =>
          ter.territory_definition_name === value ||
          ter.territory_definition_name.includes(value)
      );
      setTerritoryAllocationList(list);
      if (list.length === 0) {
        setNoSearchData(true);
      }
    } else {
      setSearchText("");
      setLoading(true);
      let body = {
        salesOfficeID: salesOfficeID,
        territoryID: territoryID,
        currentMonth: duration,
        limit: 0,
        totalRecords: 0,
      };
      await getTerritoryAllocationList(body).then((res) => {
        setLoading(false);
        setTerritoryAllocationList(res.data);
        setTotal(res.data[0].total);
        setNoSearchData(false);
      });
    }
  };

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "territory";
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return role === "Admin" ||
    role === "SalesManager" ||
    role === "BusinessOperation" ? (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
          <h2>{lang("Menu.territoryAllocation")}</h2>
          <div className="card">
            <div className="card-body">
              {(role === "Admin" || role === "BusinessOperation") && (
                <div className="custom-radio d-inline-block">
                  <input
                    type="radio"
                    id="month1"
                    name="current-month"
                    value="1"
                    onChange={(e) => handleDurationChange(e)}
                  />
                  <label htmlFor="month1">
                    {lang("territoryDefinitionMaintenance.currentMonth")}
                  </label>
                </div>
              )}
              <div className="custom-radio d-inline-block">
                <input
                  type="radio"
                  id="month2"
                  name="current-month"
                  value="0"
                  defaultChecked
                  onChange={(e) => handleDurationChange(e)}
                />
                <label htmlFor="month2">
                  {lang("territoryDefinitionMaintenance.nextMonth")}
                </label>
              </div>
              {/* {role !== "SalesManager" && <div className="custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  id="apply-month"
                  value={applyToNext}
                  onChange={(e) => handleApplyToNext(e)}
                  disabled={duration == 1 ? false : true}
                />
                <label htmlFor="apply-month">
                  {lang("territoryDefinitionMaintenance.applyToNext")}
                </label>
              </div>} */}
              {errors.duration && (
                <p className="error-text">{lang(`${errors.duration}`)}</p>
              )}
              <div className="row mt-3">
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>{" "}
                      {lang("territoryDefinitionMaintenance.BU")}
                    </label>
                    <Select
                      className="ant-select"
                      options={buList}
                      onChange={handleBUChange}
                      loading={buLoading === true ? true : false}
                      value={{ value: buID, label: buName }}
                      allowClear={buID ? true : false}
                      showSearch={buList && buList.length > 0 ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.bu && (
                      <p className="error-text">{lang(`${errors.bu}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>{" "}
                      {lang("territoryDefinitionMaintenance.division")}
                    </label>
                    <Select
                      className="ant-select"
                      options={divisionList}
                      value={{ value: divisionID, label: divisionName }}
                      onChange={handleDivisionChange}
                      loading={divisionLoading}
                      disabled={buID ? false : true}
                      allowClear={divisionID ? true : false}
                      showSearch={
                        divisionList && divisionList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.division && (
                      <p className="error-text">{lang(`${errors.division}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>{" "}
                      {lang("territoryDefinitionMaintenance.branch")}
                    </label>
                    <Select
                      className="ant-select"
                      options={branchList}
                      onChange={handleBranchChange}
                      value={{ value: branchID, label: branchName }}
                      disabled={divisionID ? false : true}
                      loading={branchLoading}
                      allowClear={branchID ? true : false}
                      showSearch={
                        branchList && branchList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.branch && (
                      <p className="error-text">{lang(`${errors.branch}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>{" "}
                      {lang("territoryDefinitionMaintenance.salesOffice")}
                    </label>
                    <Select
                      className="ant-select"
                      options={salesOfficeList}
                      value={{ value: salesOfficeID, label: salesOfficeName }}
                      onChange={handleSalesOfficeChange}
                      loading={salesOfficeLoading}
                      disabled={branchID ? false : true}
                      allowClear={salesOfficeID ? true : false}
                      showSearch={
                        salesOfficeList && salesOfficeList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.salesOffice && (
                      <p className="error-text">
                        {lang(`${errors.salesOffice}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>{" "}
                      {lang(
                        "territoryDefinitionMaintenance.territorySetToMaintain"
                      )}
                    </label>
                    <Select
                      className="ant-select"
                      options={territoryList}
                      value={{ value: territoryID, label: territoryName }}
                      onChange={handleTerritoryChange}
                      loading={territoryLoading}
                      disabled={salesOfficeID ? false : true}
                      allowClear={territoryID ? true : false}
                      showSearch={
                        territoryList && territoryList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.territory && (
                      <p className="error-text">
                        {lang(`${errors.territory}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div
                  style={{ alignItems: "center" }}
                  className="steps-action1 col-2"
                >
                  {/* {loading && <Spinner animation="border" />} */}
                  <button
                    className="btn btn-primary"
                    onClick={handleTerritoryAllocation}
                    disabled={loading}
                  >
                    {lang("Buttons.apply")}
                  </button>
                </div>
                {/* <div className="employeeMessage col-10">
                <p className="annotation">
                    {" "}
                    {lang("territoryAllocationMaintenance.employeeMessage")}
                  </p>
                  <p className="annotation">
                    {" "}
                    {lang("territoryAllocationMaintenance.employeeMessage2")}
                  </p>
                </div> */}
              </div>
            </div>
          </div>
          {(territoryAllocationList.length > 0 || noSearchData) && (
            <div className="searchwith-title">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Territory Allocations"
                  value={searchText}
                  onChange={(e) => handleTerritorySearch(e.target.value)}
                />
                <button className="search-btn">
                  <em
                    className="bx bx-search"
                    // onClick={handleTerritorySearch("")}
                  ></em>
                </button>
              </div>
            </div>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && (
            <div className="noData">{lang("errorMessages.NO_DATA")}</div>
          )}
          {noSearchData && (
            <div className="noData">{lang("errorMessages.NO_DATA")}</div>
          )}
          {territoryAllocationList &&
            territoryAllocationList.length > 0 &&
            loading === false && (
              <div className="searchwith-title">
                <div className="total-records">
                  <p className="record-total mb-0">
                    {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                    {territoryAllocationList.length} / {total}
                  </p>
                </div>
              </div>
            )}
          {territoryAllocationList.length > 0 && loading === false && (
            <div
              // ref={containerRef}
              className="table-responsive mb-0 hover-table max-height"
            >
              <table className="table" aria-describedby="table">
                <thead>
                  <tr>
                    <th scope="col">
                      {lang(
                        "territoryAllocationMaintenance.territoryAllocations"
                      )}
                    </th>
                    <th scope="col">
                      {lang("territoryAllocationMaintenance.employee")}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {territoryAllocationList.map((ter, i) => {
                    let val = {};
                    employeeList.map((emp) => {
                      emp.options.map((x) => {
                        if (x.value === ter.employee_id) {
                          val = x;
                        }
                      });
                    });
                    return (
                      <tr
                        key={i}
                        id={ter.id}
                        onFocus={() => handleId(ter.id)}
                        className={isOpen ? "menu-open" : "menu-closed"}
                      >
                        {/* <Tip
        placement="top"
        align={{ overflow: { adjustX: true, adjustY: true } }}
        overlay={
          <div
            style={{
              display: "inline-block",
              width: 'fit-width',
              height :'fit-width',
              padding: '6px',
              background: "white",
              opacity: 1
            }}
          >
          <div style={{ color: 'black', fontSize : '18px',fontWeight : '500' }} >{`${lang("territoryDefinitionMaintenance.updatedBy")} : ${ter.updated_by ? ter.updated_by : '' }`}</div>
          <div style={{ color: 'black', fontSize : '18px',fontWeight : '500' }}>{`${lang("territoryDefinitionMaintenance.lastUpdate")} : ${ter.last_updated_at ? ter.last_updated_at : '' }`}</div>
          </div>
        }
      > */}
                        <td>
                          {ter.territory_definition_name}
                          <br></br>
                          <span
                            style={{ color: "darkgray", fontSize: "0.68rem" }}
                          >
                            {`${lang(
                              "territoryDefinitionMaintenance.updatedBy"
                            )} : ${
                              ter.updated_by ? ter.updated_by : `System`
                            } `}
                            ,
                            {` ${lang(
                              "territoryDefinitionMaintenance.lastUpdate"
                            )} : ${
                              ter.last_updated_at
                                ? ter.last_updated_at
                                : `System`
                            }`}
                          </span>
                          {/* </Tip> */}
                        </td>
                        <td>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions={employeeList}
                            isClearable={true}
                            defaultValue={val}
                            showSearch
                            className="ant-select"
                            options={employeeList}
                            onChange={(value) => {
                              handleFinalArray(i, value);
                              if (value) {
                                handleEmployeeChange(value, i);
                              } else {
                                let obj = {
                                  territoryDefinition: ter.id,
                                  allocatedEmployee: "",
                                };
                                setSelectedTerritoryAllocationList([
                                  ...selectedTerritoryAllocationList,
                                  obj,
                                ]);
                                if (errorList.includes(ter.id)) {
                                  errorList.filter((item) => item !== ter.id);
                                  setErrorList(errorList);
                                }
                              }
                            }}
                            placeholder="Please select employee"
                            onMenuOpen={() => setIsOpen(true)}
                            onMenuClose={() => {
                              setIsOpen(false);
                              resetEmployeeList();
                            }}
                            loadOptions={(inputValue) =>
                              handleEmployeeSearch(inputValue)
                            }
                          />
                        </td>
                        <td>
                          {/* {errorList.includes(ter.id) && (
                            <p className="alert alert-danger">
                              {lang("errorMessages.NON_MR_EMPLOYEE")}
                            </p>
                          )} */}
                          {ter.error && (
                            <p className="alert alert-danger">
                              {lang("errorMessages.NON_MR_EMPLOYEE")}
                            </p>
                          )}
                          {/* {errorList.includes(ter.employee_wwid)&& (
                            <p className="alert alert-danger">
                              {lang("errorMessages.NON_MR_EMPLOYEE")}
                            </p>
                          )} */}
                          {/* {warningList.includes(ter.id) && (
                            <p className="alert alert-warning">
                              {lang("errorMessages.OTHER_SALES_OFFICE_MR")}
                            </p>
                          )} */}
                          {ter.warning && (
                            <p className="alert alert-warning">
                              {lang("errorMessages.OTHER_SALES_OFFICE_MR")}
                            </p>
                          )}
                          {/* {warningList.includes(ter.employee_wwid) && (
                            <p className="alert alert-danger">
                              {lang("errorMessages.NON_MR_EMPLOYEE")}
                            </p>
                          )} */}
                          {/* {ter.id === error && <p className="alert alert-danger">Non-MR employee is allocated</p>} */}
                          {/* {ter.id === warning && <p className="alert alert-warning">MR in other sales office is allocated. </p>} */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {total !== territoryAllocationList.length && (
            <div className="steps-action1 mt-4">
              {lazyLoading && <Spinner animation="border" />}
              <button
                className="btn btn-primary"
                onClick={loadRecords}
                disabled={lazyLoading}
              >
                {lang("Buttons.loadMore")}
              </button>
            </div>
          )}
          {territoryAllocationList.length > 0 && loading === false && (
            <div className="employeeList save-action mb-4 mt-4">
              {resultLoading && <Spinner animation="border" />}
              <button
                className="btn btn-primary"
                onClick={saveTerritoryAllocationDetails}
                disabled={resultLoading || disableSave}
              >
                {lang("Buttons.save")}
              </button>
              <div style={{ display: "flex", marginTop: "4px" }}>
                <p
                  style={{ marginRight: "4px", fontSize: "larger" }}
                >{`*  `}</p>
                <p style={{ fontSize: "small" }}>{`  mandatory field`}</p>
              </div>
            </div>
          )}
          <Modal
            size="sm"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {lang("errorMessages.SAVE_SUCCESS")}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="sm"
            className="withdraw-modal"
            show={showErrorMessage}
            onHide={handleCloseErrorMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />{" "}
                {lang("errorMessages.NON_MR_EMPLOYEE")}
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseErrorMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="sm"
            className="withdraw-modal"
            show={allocAPIFail}
            onHide={handleCloseErrorMessageAPIFail}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />{" "}
                {lang("errorMessages.ALLOCATION_FAIL")}
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseErrorMessageAPIFail}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </Home>
  ) : (
    <Home>
      <p>You don't have required permission to view this page</p>
    </Home>
  );
}

export default TerritoryAllocation;
